import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = () => {
  return (
    <ContentLoader
      speed={2}
      width={690}
      height={275}
      viewBox={`0 0 690 275`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <>
        <rect x="20" y="25" rx="3" ry="3" width="500" height="14" />

        <rect x="20" y="64" rx="3" ry="3" width="82" height="10" />
        <rect x="20" y="83" rx="3" ry="3" width="260" height="38" />

        <rect x="20" y="152" rx="3" ry="3" width="30" height="10" />
        <rect x="20" y="171" rx="3" ry="3" width="250" height="34" />
        <rect x="289" y="152" rx="3" ry="3" width="112" height="10" />
        <rect x="289" y="171" rx="3" ry="3" width="260" height="38" />
      </>
    </ContentLoader>
  );
};

export default Loader;
